// import React from "react";
import { Routes, Route } from "react-router-dom";
import "../sportOnePages/SportOneHome.scss";

import SportOneHome from "../sportOnePages/SportOneHome";
import GlobalRoute from "../../../../global route/GlobalRoute";
import Navbar from "../../../../default-components/Navbar";
import BusinessThreeNavbar from "../../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import SportOneFooter from "../sportOneComponents/SportOneFooter";
const SportOneRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");

  return (
    <div className="sport_one_main_route">
      {navTypeDoc?.activeNav === "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}

      <Routes>
        <Route path="/" element={<SportOneHome />} />
      </Routes>
      <GlobalRoute />
      <SportOneFooter />
    </div>
  );
};

export default SportOneRoute;
